/* eslint-disable */
import { messageTableConstants } from '../constants/messageTableConstants';
import { messageTableServices } from '../../services/messageTableServices';

export const messagesTableActions = {
    getMessageTable,
    updateMessageTable,
    resetUpdateMessageTable
};

function getMessageTable(slug, params, data, isPost) {
    return dispatch => {
        dispatch(request());

        if (isPost) {
            messageTableServices.post(slug, data, params)
                .then(
                    response => {
                        if (response && (!('errorCode' in response) || null === response.errorCode) && !response.error) {
                            dispatch(success(response));
                        } else {
                            dispatch(error(response.status ? response.status : null));
                        }
                    }
                );
        } else {
            messageTableServices.get(slug, params)
                .then(
                    response => {
                        if (response && typeof response === 'object' && !response.error) {
                            dispatch(success(response));
                        } else {
                            dispatch(error());
                        }
                    }
                );
        }

    };

    function request() { return { type: messageTableConstants.MESSAGE_TABLE_REQUEST }; }

    function success(data) { return { type: messageTableConstants.MESSAGE_TABLE_SUCCESS, slug: slug, data }; }

    function error() { return { type: messageTableConstants.MESSAGE_TABLE_ERROR }; }
}

function updateMessageTable(slug, data, callback, params) {
    return dispatch => {
        dispatch(request());

        messageTableServices.post(slug, data, params)
            .then(
                response => {
                    if (response && (!('errorCode' in response) || null === response.errorCode) && !response.error) {
                        dispatch(success(response, callback));
                    } else {
                        dispatch(error(response.status ? response.status : null));
                    }
                }
            );
    };

    function request() { return { type: messageTableConstants.MESSAGE_TABLE_POST_REQUEST }; }

    function success(data) { return { type: messageTableConstants.MESSAGE_TABLE_POST_SUCCESS, slug: slug, data, callback: callback }; }

    function error(status) { return { type: messageTableConstants.MESSAGE_TABLE_POST_ERROR, status: status, callback: callback }; }
}

function resetUpdateMessageTable() {
    return {
        type: messageTableConstants.MESSAGE_TABLE_POST_RESET
    };
}
